import { render } from "./KtgdealersearchAutocomplete.vue?vue&type=template&id=5c707b88"
import script from "./KtgdealersearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./KtgdealersearchAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominikheun/Coding/ktg-dealersearch-relaunch-typo3/extensions/ktg-dealersearch-extension-typo3/Resources/Private/Vue/dealersearch-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__